import * as tslib_1 from "tslib";
import React from 'react';
import { useBiClickLogger } from '../hooks/useBiClickLogger';
var BiSpan = function (_a) {
    var biData = _a.biData, props = tslib_1.__rest(_a, ["biData"]);
    var setTrackingRef = useBiClickLogger(biData).setTrackingRef;
    return React.createElement("span", tslib_1.__assign({}, props, { ref: setTrackingRef }));
};
BiSpan.displayName = 'BiSpan';
export default BiSpan;
//# sourceMappingURL=BiSpan.js.map